<template>
  <div class="wechatComplaint div-layout">
    <div v-if="!dialogAddVisible&&!dialogDetailVisible" class="wechatComplaint-main">
      <module-title title="街道社区配置">
        <div class="right">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-plus"
            @click="opAddOrView('add')"
          >
            添加社区
          </el-button>
        </div>
      </module-title>
      <div class="wechatComplaint-main-contain">
        <el-form
          ref="searchForm"
          :model="searchForm"
          :inline="true"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="所属区域：" prop="areaCode">
            <el-cascader
              v-model="searchForm.areaCode"
              :options="areaData"
              :props="areaProps"
              class="handle-form-input"
              clearable
              placeholder="选择省/市/区县"
              @change="areaChange"
            />
          </el-form-item>
          <el-form-item label="所属街道：" prop="streetId">
            <el-select
              v-model="searchForm.streetId"
              name="streetId"
              size="medium"
              class="handle-form-input"
            >
              <el-option label="全部" value="" />
              <el-option
                v-for="item in streetsList"
                :key="item.id"
                :label="item.streetName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item style=" margin-left:50px;">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
        <el-table
          v-loading="listLoading"
          :data="dataList"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="所属区域" prop="areaJoinName" align="center" />
          <el-table-column label="所属于街道" prop="streetName" align="center" />
          <el-table-column label="社区数量" prop="communityNum" align="center" />
          <el-table-column label="启动状态" prop="status" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.status===1?'已开启':'已停用' }}
            </template>
          </el-table-column>
          <el-table-column label="添加时间" prop="createDate" align="center" />
          <el-table-column label="操作" align="center" width="200px">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="viewCodeDetail(scope.row)"
              >
                查看
              </el-button>
              <el-button
                v-if="scope.row.status===2"
                type="text"
                size="small"
                @click="handleUseEdit(scope.row)"
              >
                启用
              </el-button>
              <el-button
                v-if="scope.row.status===1"
                type="text"
                size="small"
                @click="handleUseEdit(scope.row)"
              >
                停用
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <Detail v-if="dialogDetailVisible" :detail-props="detailProps" @back="backAdd('detail')" />
    <Add v-if="dialogAddVisible" :detail-props="detailProps" @back="backAdd('add')" />
  </div>
</template>

<script>

import {
  get_street_pagelist,
  update_Status,
  getStreets
} from '@/api/systemMaintenance/devicManage/cascaderConfig';
import { mapGetters } from 'vuex';
import Detail from './detail.vue';
import Add from './add.vue';
export default {
  name: 'CascaderConfig',
  components: { Detail, Add },
  data() {
    return {
      dialogAddVisible: false,
      dialogDetailVisible: false,
      areaProps: {
        value: 'code',
        label: 'name',
        children: 'children',
        checkStrictly: true
      },
      detailProps: {},
      ajaxLoading: false,
      // 搜索表单
      searchForm: {
        areaCode: '',
        provinceId: '',
        cityId: '',
        areaId: '',
        streetId: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      dateTime: '',
      dataList: [],
      streetsList: [],
      listLoading: false, // 表格刷新loading
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now(); // 如果没有后面的-8.64e7就是不可以选择今天
        }
      } // 时间控件限制
    };
  },
  computed: {
    ...mapGetters(['areaData'])
  },
  mounted() {
    this.$store.dispatch('getNodes'); // 获取区域
    this.fetchdataList();
  },
  methods: {
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchdataList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchdataList();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchdataList();
    },
    backAdd(val) {
      val === 'detail' ? this.dialogDetailVisible = false : this.dialogAddVisible = false;
      this.fetchdataList();
    },
    areaChange(val) {
      this.searchForm.provinceId = val[0] ? val[0] : '';
      this.searchForm.cityId = val[1] ? val[1] : '';
      this.searchForm.areaId = val[2] ? val[2] : '';
      this.searchForm.streetId = '';
      this.fetchStreet();
    },
    fetchStreet() {
      var op = {
        provinceId: this.searchForm.provinceId,
        cityId: this.searchForm.cityId,
        areaId: this.searchForm.areaId
      };
      getStreets(op).then(res => {
        if (res.data && res.data.length > 0) {
          this.streetsList = res.data;
        } else {
          this.streetsList = [];
        }
      }).catch(err => {
        console.log(err);
        this.$message.warning('请求错误');
      });
    },
    handleSearchReset() {
      this.searchForm = {
        areaCode: '',
        provinceId: '',
        cityId: '',
        areaId: '',
        streetId: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      };
    },
    opAddOrView() {
      this.dialogAddVisible = true;
      this.dialogDetailVisible = false;
    },
    // 查看
    viewCodeDetail(row) {
      this.detailProps = row;
      this.dialogAddVisible = false;
      this.dialogDetailVisible = true;
    },
    // 启用停用
    handleUseEdit(row) {
      this.$confirm(
        `确定要${row.status === 1 ? '停用' : '启用'}该社区么?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          const form = {
            status: row.status === 1 ? 2 : 1
          };
          return update_Status(form, row.id);
        })
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: `${row.status === 1 ? '停用' : '启用'}成功`,
            showClose: false,
            duration: 2000
          });
          this.fetchdataList();
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取应用列表
    fetchdataList() {
      this.listLoading = true;
      var op = {
        provinceId: this.searchForm.areaCode && this.searchForm.areaCode[0],
        cityId: this.searchForm.areaCode && this.searchForm.areaCode[1],
        areaId: this.searchForm.areaCode && this.searchForm.areaCode[2],
        id: this.searchForm.streetId,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      get_street_pagelist(op)
        .then(result => {
          if (result.data && result.data.list && result.data.list.length) {
            this.dataList = result.data.list;
            this.searchForm.total = result.data.total;
          } else {
            this.dataList = [];
            this.searchForm.total = 0;
          }
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.listLoading = false;
          this.dataList = [];
          this.searchForm.total = 0;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.wechatComplaint {
  padding-bottom: 20px;
  .handle-form-input {
    width: 80%;
  }
  .handle-form-input1{
    width: 50%;
  }
}
</style>

